import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["Investment", "Owner-occupied", "Refinance"];

const FEATURE_CARDS = [
  {
    title: "Commercial repayment modelling",
    description:
      "Estimate indicative monthly costs across fixed, variable, and blended commercial mortgage structures.",
  },
  {
    title: "Use-case matching",
    description:
      "Align with lenders who fund offices, retail, industrial, and other commercial security types.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, compare commercial terms side by side and continue to digital application in one place.",
  },
];

const STEPS = [
  {
    title: "Describe the commercial property",
    body: "Value, occupancy, lease strength, and business use determine which commercial lenders engage.",
  },
  {
    title: "Compare mortgage terms",
    body: "Review indicative rates, fees, and term options tailored to investment or trading premises.",
  },
  {
    title: "Shortlist and apply",
    body: "Save preferred commercial products and apply when commercial sourcing goes live on Dynesourcer.",
  },
];

const CRITERIA_CHIPS = [
  "Property type & location",
  "Loan purpose (purchase, refinance, capital release)",
  "Loan amount & LTV",
  "Investment vs owner-occupied",
  "Tenant & WAULT (if let)",
  "Trading history (if trading)",
  "Interest rate type",
  "Repayment term & profile",
  "Specialist sectors (e.g. care, hospitality)",
];

export default function CommercialCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Commercial"
      heroTitle="Commercial Mortgage Calculator"
      heroDescription="Investment and owner-occupied commercial property finance with lender-led matching. Coming soon."
      heroSrc="/Commerical.webp"
      primaryCtaText="Source commercial mortgages (Coming soon)"
      heroTags={HERO_TAGS}
      introTitle="Commercial mortgage calculator (Coming soon)"
      introBody="Dynesourcer will help borrowers stress-test commercial mortgage costs and filter lenders by property use, lease profile, and trading strength. This page is a preview while we onboard commercial data."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How commercial mortgages will work on Dynesourcer"
      howItWorksIntro="You outline the asset and how it’s used; we return commercial lenders whose criteria fit the scenario."
      steps={STEPS}
      criteriaTitle="Typical commercial criteria (preview)"
      criteriaIntro="Commercial underwriting blends property, tenant, and business risk. These chips reflect common filters."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Exploring commercial property finance?"
      ctaDescription="See how Dynesourcer guides borrowers end-to-end. Commercial calculator outputs will land on this route at launch."
      ctaPrimary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
      ctaSecondary={{ to: "/sourcing/buy-to-let-mortgage-sourcing", label: "Try BTL sourcing today" }}
    />
  );
}
